import { Component,AfterViewInit, ViewChild, ElementRef, HostListener, Renderer2, isDevMode } from '@angular/core';
import { DownloadProgressService } from './_service/download-progress.service';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart } from '@angular/router';
import { IndexedDbServiceService } from './_service/indexed-db-service.service';
import { App } from '@capacitor/app';
import { AuthenticateserviceService } from './_service/authenticateservice.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { filter } from 'rxjs/operators';
import { WhiteLabelService } from './_service/white-label.service';
import { CategoryService } from './_service/category.service';
import { ConnectivityService } from './_service/connectivity.service';
import { IosBridgeService } from './_service/ios-bridge.service';
import { ScrollService } from './_service/scroll.service';
import { UpdateService } from './_service/update.service';
import { TranslateService } from '@ngx-translate/core';
import { AxinomDrmService } from './_service/axinom-drm.service';
import { ManifestService } from './_service/manifest.service';
import { URLS } from './constants/URLS';
import { DeviceService } from './_service/tv-detect.service';
import { SentryPerformanceService } from './_service/sentry-performance.service';
import { DrmCapabilityService } from './_service/drm-capability.service';

declare let shaka: any | undefined;
declare var window: any | undefined;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  // animations: [
  //   trigger('fadeInOut', [
  //     state('in', style({ opacity: 1 })),
  //     transition(':enter', [
  //       style({ opacity: 0 }),
  //       animate(300)
  //     ]),
  //     transition(':leave',
  //       animate(300, style({ opacity: 0 })))
  //   ])
  // ]
})

export class AppComponent implements AfterViewInit{
  title = 'Rich-UI-toqqer';
  isMiniPlayer:boolean = false;
  @ViewChild('video') video: ElementRef | undefined;
  isLoggedIn:boolean = false;
  isMobile:boolean = false;
  isPlayerRoute: boolean = false;
  isRegisterRoute: boolean = false;
  isLoginRoute: boolean = false;
  isOnline:boolean = false;
  isVideoDetailsRoute: boolean = false;
  toastVisible = false;
  status:string = 'online';
  isShortDrama:boolean = false;
  isShortsRoute:boolean = false;
  isDownloadRoute:boolean = false;
  deferredPrompt: any;
  showInstallBanner = false;
  private lastScrollPositions = new Map<string, number>();
  private currentUrl = '';
  folder = 'toqqer';
  channel = 'Toqqer';
  countdown: string = '';
  showMarquee: boolean = true;
  launchDate = new Date('2026-03-01T00:00:00');
  days = '00';
  hours = '00';
  minutes = '00';
  seconds = '00';
  private timerId: any;
  @ViewChild('marqueeContent', { static: false }) marqueeContent!: ElementRef<HTMLDivElement>;

isDragging = false;
startX = 0;
lastTranslateX = 0;
currentTranslateX = 0;
channelIdCache = '';
channelUrl: string = URLS.channelUrl;
// TV Navigation Test state (remove after Phase 1 verification)
lastTestClick = 'None';
  constructor(
    private downloadProgressService: DownloadProgressService, 
    private router: Router,
    private indexedDBService: IndexedDbServiceService,
    private networkStatusService: AuthenticateserviceService, 
    private breakerPointObserver: BreakpointObserver,
    private categ: CategoryService,
    private connectivity: ConnectivityService,
    private bridgeService: IosBridgeService,
    private scrollService: ScrollService,
    private route: ActivatedRoute,
    private wl: WhiteLabelService,
    private updateService: UpdateService,
    private translate: TranslateService,
    private axinomService: AxinomDrmService,
    private renderer: Renderer2,
    private deviceService: DeviceService,
    private sentryPerf: SentryPerformanceService,
    private drmCapability: DrmCapabilityService
    ) {
      this.translate.addLangs(['en', 'te', 'hi', 'id', 'af', 'zu', 'de', 'ru']);
      this.translate.setDefaultLang('en');
      const lang = localStorage.getItem('lang') || 'en';
      this.translate.use(lang);
      this.isLoggedIn = this.networkStatusService?.isAuthenticated();
      // Set Sentry user context for regional performance filtering
      const userId = localStorage.getItem('userId') || localStorage.getItem('token')?.substring(0, 8) || '';
      const channelId = localStorage.getItem('wl_content_provider_id') || '';
      if (userId) {
        this.sentryPerf.setUserContext(userId, undefined, channelId);
      }
      // document.addEventListener('DOMContentLoaded', this.initApp);
      const lastPositions = new Map<string, number>();
      let currentUrl = '';
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (currentUrl) {
            lastPositions.set(currentUrl, window.scrollY);
          }
        }
      });
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          // TV pages own their scroll position via row-based repositioning
          // (CategoryMovieComponent.scheduleActiveRowReposition, etc.). Restoring
          // a saved scrollY from a previous visit fights the row reposition and
          // can lock the page at a stale wrong scroll (e.g. carousel rendered
          // on top of the hero preview). Web/mobile flows still use the saved
          // position memory.
          if (this.deviceService.isTV()) {
            currentUrl = event.urlAfterRedirects;
            return;
          }
          const savedScroll = lastPositions.get(event.urlAfterRedirects);
          requestAnimationFrame(() => {
            if (savedScroll !== undefined) {
              window.scrollTo({ top: savedScroll, behavior: 'auto' });
            } else {
              window.scrollTo({ top: 0, behavior: 'auto' });
            }
          });
          currentUrl = event.urlAfterRedirects;
        }
      });
      this.channelIdCache = localStorage.getItem('wl_content_provider_id') || '';
    // if(typeof window.CustomEvent !== 'function') {
    //   function CustomEvent(event, params) {
    //     params = params || { bubbles: false, cancelable: false, detail: undefined };
    //     var evt = document.createEvent('CustomEvent');
    //     evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    //     return evt;
    //   }
    //   CustomEvent.prototype = window.Event.prototype;
    //   window.CustomEvent = CustomEvent; 
    // }
  }

  ngOnInit() {
    // this.manifestService.updateManifest();
    if (this.isAndroidTV()) {
      document.body.classList.add('tv-mode');
      // Disable smooth scrolling on TV. Global `html { scroll-behavior: smooth }`
      // in styles.css makes every window.scrollTo animate over ~500ms — which
      // breaks the row-reposition defender in CategoryMovieComponent because
      // each 50ms tick restarts a fresh 500ms animation that never completes.
      // Web/mobile users keep the smooth scrolling; TV uses instant scroll so
      // the defender can lock the page at the correct row position immediately.
      document.documentElement.style.scrollBehavior = 'auto';
    }

    // Dev-only: Press Shift+T to toggle TV mode for testing
    if (isDevMode()) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'T' && e.shiftKey) {
          document.body.classList.toggle('tv-mode');
          this.deviceService.toggleTV();
        }
      });
    }
    this.networkStatusService.isAuthenticated$.subscribe(
      (isAuthenticated: boolean) => {
        this.isLoggedIn = isAuthenticated;
      }
    );
    this.breakerPointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
    });
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: any) => { 
      const currentUrl = this.router.url;
      const queryParams = this.route.snapshot.queryParams;
      this.isPlayerRoute = (event.url.includes(['/watch']) && (event.url.includes(['/movies']) || event.url.includes(['shows']) || event.url.includes(['/trailer']))) || event.url.includes(['/live/event/']);
      this.isDownloadRoute = event.url.includes(['downloads'])
      this.isShortDrama = currentUrl.includes('/watch') && currentUrl.includes('/shows') && queryParams['aspect'] === 'short-vertical';
      this.isShortsRoute = event.url.includes('/shorts/');
      this.isRegisterRoute = event.url.includes(['/registration']);
      this.isLoginRoute = event.url.includes(['/login']);
      this.isVideoDetailsRoute = currentUrl.includes('/movies/') || currentUrl.includes('/shows/');
    });
    const userId = localStorage.getItem("userId");
    this.connectivity.status$.subscribe((result)=>{
      this.status = result;
    })
    window.addEventListener('beforeinstallprompt', (event: any) => {
      event.preventDefault(); 
      this.deferredPrompt = event;
      this.showInstallBanner = true; 
    });
    window.addEventListener('appinstalled', () => {
      this.showInstallBanner = false;
      this.deferredPrompt = null;
    });
    localStorage.setItem('imgCacheVersion', Date.now().toString());
    if (!localStorage.getItem("drm_persistent_session") && this.isMobile) {
      const drmSession = {
        "sessionId": "7535F8C1411AC951A6F9CEACF8797C37",
        "initData": [0, 0, 0, 84, 112, 115, 115, 104, 0, 0, 0, 0, 237, 239, 139, 169, 121, 214, 74, 206, 163, 200, 39, 220, 213, 29, 33, 237, 0, 0, 0, 52, 8, 1, 18, 16, 121, 87, 174, 154, 134, 165, 87, 180, 153, 162, 75, 171, 104, 224, 144, 24, 26, 8, 109, 111, 118, 105, 100, 111, 110, 101, 34, 16, 89, 4, 67, 221, 166, 72, 127, 78, 187, 21, 49, 202, 43, 121, 201, 67, 42, 2, 83, 68],
        "initDataType": "cenc"
      };
      localStorage.setItem("drm_persistent_session", JSON.stringify(drmSession));
    }
    if(this.wl.isWhiteLabelMode){
      this.channel = localStorage.getItem('wl_channel');
      if(this.channel == '@HomeCinema'){
        this.folder = 'limpopo';
      }else if(this.channel == '@mandela.pictures'){
        this.folder = 'mandela';
      }
    }
    this.startCountdown();
  }

  ngOnDestroy() {
    if (this.timerId) clearInterval(this.timerId);
  }

  private setTranslateX(x: number) {
    this.currentTranslateX = x;
    this.renderer.setStyle(this.marqueeContent.nativeElement, 'transform', `translate3d(${x}px,0,0)`);
  }
  
  onDragStart(event: MouseEvent) {
    this.isDragging = true;
    this.startX = event.clientX;
    this.lastTranslateX = this.currentTranslateX;
    document.body.style.cursor = 'grabbing';
  }
  
  onDragMove(event: MouseEvent) {
    if (!this.isDragging) return;
    const dx = event.clientX - this.startX;
    this.setTranslateX(this.lastTranslateX + dx);
  }
  
  onTouchStart(event: TouchEvent) {
    this.isDragging = true;
    this.startX = event.touches[0].clientX;
    this.lastTranslateX = this.currentTranslateX;
  }
  
  onTouchMove(event: TouchEvent) {
    if (!this.isDragging) return;
    const dx = event.touches[0].clientX - this.startX;
    this.setTranslateX(this.lastTranslateX + dx);
  }
  
  onDragEnd() {
    if (!this.isDragging) return;
    this.isDragging = false;
    document.body.style.cursor = 'default';
  
    // ✅ resume animation after small delay
    setTimeout(() => {
      this.currentTranslateX = 0;
      this.renderer.removeStyle(this.marqueeContent.nativeElement, 'transform');
    }, 200);
  }
  startCountdown() {
    const launchDate = new Date('2026-03-31T00:00:00');
    this.timerId = setInterval(() => {
      const now = new Date();
      const diff = launchDate.getTime() - now.getTime();
      if (diff <= 0) {
        this.showMarquee = false;
        clearInterval(this.timerId);
        return;
      }
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);
      this.days = String(d).padStart(2, '0');
      this.hours = String(h).padStart(2, '0');
      this.minutes = String(m).padStart(2, '0');
      this.seconds = String(s).padStart(2, '0');
    }, 1000);
  }

  isAndroidTV(): boolean {
    return !!(window as any)?.AndroidTV;
  }

  // TV Navigation Test (remove after Phase 1 verification)
  get isTV(): boolean {
    return this.deviceService.isTV();
  }

  onTestClick(name: string): void {
    this.lastTestClick = name;
    console.log('TV Navigation Test - Clicked:', name);
  }

  onToastChange(value: boolean) {
    console.log('toastVisible changed:', value);
    this.toastVisible = value;
  }

  checkDRMSupport(): void {
    navigator.requestMediaKeySystemAccess('com.widevine.alpha', [{
      initDataTypes: ['cenc'],
      persistentState: 'required',
      sessionTypes: ['persistent-license'],
      videoCapabilities: [{ contentType: 'video/mp4; codecs="avc1.640028"' }]
    }])
    .then(() => {
      console.log("✅ Persistent license is supported in this environment.");
    })
    .catch((err) => {
      console.error("❌ Persistent license NOT supported:", err.message);
    });
  }
  
  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: any) {
    event.preventDefault();
    this.deferredPrompt = event;
  }

  async installPWA() {
    if (!this.deferredPrompt) return;
    this.deferredPrompt.prompt();
    const choiceResult = await this.deferredPrompt.userChoice;
    if (choiceResult.outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
    this.showInstallBanner = false;
    this.deferredPrompt = null;
  }

  private async showExitConfirmation() {
    const shouldExit = confirm('Do you want to exit the app?');
    if (shouldExit) {
      App.exitApp();
    }
  }

  async ngAfterViewInit() {
    if (await this.drmCapability.supportsPersistentLicense()) {
      this.initPlayer();
    } else {
      console.info('[DRM] Persistent license unsupported — skipping bootstrap Shaka storage init. Offline downloads disabled for this environment.');
    }
  }

  initApp() {
    shaka.polyfill.installAll();
    if (shaka.Player.isBrowserSupported()) {
      this.initPlayer();
    } else {
      console.error('Browser not supported!');
    }
  }

  async initPlayer() { 
    console.log("initPlayer method called"); 
    let video = this.video.nativeElement; 
    const player = new shaka.Player(video); 
    shaka.polyfill.installAll();
    const token: string = this.axinomService.getWidevineToken(); 
    await this.indexedDBService.ensureDbInitialized(); 
    const drmServersConfig = { 
      'com.widevine.alpha': this.axinomService.getWidevineUrl() 
    }; 
    player.configure({ 
      drm: { 
        servers: drmServersConfig, 
        advanced: {
          "com.widevine.alpha": {
            persistentStateRequired: true
          }
        },
      } 
    }); 
    player.getNetworkingEngine().registerRequestFilter((type, req) => {
      if (type === shaka.net.NetworkingEngine.RequestType.LICENSE) {
        req.headers["X-AxDRM-Message"] = token;
        req.headers["Content-Type"] = "application/octet-stream";
      }
    });
    player.addEventListener('error', this.onErrorEvent.bind(this)); 
    this.initStorage(player); 
  }
 
  onErrorEvent(event) {
    this.onError(event.detail);
  }

  onError(error) {
    console.error('Error code', error.code, 'object', error);
  }

  initStorage(player) {
    window.storage = new shaka.offline.Storage(player);
    window.storage.configure({
      drm: {
        servers: { "com.widevine.alpha": this.axinomService.getWidevineUrl() },
        advanced:{
          "com.widevine.alpha":{
            persistentStateRequired:true
          }
        }
      },
      // networking: {
      //   requestFilter:(type,req)=>{
      //     if(type===shaka.net.NetworkingEngine.RequestType.LICENSE){
      //       req.headers["X-AxDRM-Message"]=this.axinomService.getWidevineToken();
      //       req.headers["Content-Type"]="application/octet-stream";
      //     }
      //   }
      // },
      offline: {
        progressCallback: this.setDownloadProgress
      },
      // retryParameters: {
      //   maxAttempts: 5,
      //   baseDelay: 500,
      //   backoffFactor: 2.0
      // }
    });
    this.reconcileIncompleteDownloads();
  }

  private async reconcileIncompleteDownloads() {
    try {
      const list = await window.storage.list();
      const partials = (list || []).filter(i => !i.offlineUri); 
      if (!partials.length) return;
      for (const p of partials) {
        await window.storage.remove(p.offlineUri || p.originalManifestUri || p);
      }
      // Optional toast:
      // this.downloadProgressService.resetDownloadItems();
      // (You can show a soft info toast somewhere: "A previous download was interrupted and has been cleared.")

      // —————— OPTION B: AUTO-RESUME (enable if you want) ——————
      // for (const p of partials) {
      //   try {
      //     const meta = p.appMetadata || {};
      //     await window.storage.remove(p.offlineUri || p.originalManifestUri || p);
      //     await window.storage.store(p.originalManifestUri, meta); // will trigger normal progress again
      //   } catch (e) {
      //     console.warn('Auto-resume failed for', p?.title || p, e);
      //   }
      // }
      sessionStorage.removeItem('toqqerDownloadInterrupted');
    } catch (e) {
      console.error('Failed to reconcile incomplete downloads:', e);
    }
  }

  selectTracks(tracks) {
    const found = tracks
      .filter((track) => track.type === 'variant')
      .sort((a, b) => a.bandwidth - b.bandwidth)
      .pop();
    console.log('Offline Track bandwidth: ' + found.bandwidth);
    return [found];
  }
  
  setDownloadProgress(content, progress) {
    try {
      if (content) content.progress = progress ?? content.progress ?? 0;
      const evt = new CustomEvent('downloadProgress', { detail: content });
      window.dispatchEvent(evt); 
    } catch (e) {
      console.error('[Download] progress dispatch failed:', e);
    }
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnloadConfirm(event: BeforeUnloadEvent) {
    if (this.downloadProgressService.isDownloadInprogress) {
      event.preventDefault();
      event.returnValue = '';
      sessionStorage.setItem('toqqerDownloadInterrupted', '1');
    }
  }
}